"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDismissInterstitialService = void 0;
const hooks_1 = require("../../hooks");
const useDismissInterstitialService = (repository) => {
    const { call: dismissInterstitialCall, isLoading: isDismissInterstitialLoading, isSuccess: isDismissInterstitialSuccess, isError: isDismissInterstitialError, } = (0, hooks_1.useAsyncStateInfo)(repository.dismissInterstitial);
    return {
        dismissInterstitialCall,
        isDismissInterstitialLoading,
        isDismissInterstitialSuccess,
        isDismissInterstitialError,
    };
};
exports.useDismissInterstitialService = useDismissInterstitialService;
//# sourceMappingURL=useDismissInterstitialService.hook.js.map